export default __webpack_public_path__ + "static/media/the-matter.da495956.png";